import "../App.css";
import { informationPopupBackground1, informationPopupBackground2, informationPopupBackground3, informationPopupCredits1, informationPopupCredits2, informationPopupCredits3, informationPopupCredits4, informationPopupCredits5, informationPopupCredits6, informationPopupCredits7, informationPopupCredits8, informationPopupCredits9, informationPopupDeveloper, informationPopupTechnical, informationPopupTitle, tutorialButtonPreviousPage } from "../strings";

function InformationPopup({ show, handleClose }) {


  return (
    <div style={{display: show ? "flex" : "none"}} className="information-wrapper">
      <div className="information-title">
        {informationPopupTitle}
      </div>
      <div className="information-body">
        <div>
          {informationPopupBackground1}
          <span style={{fontStyle: "italic"}}>{informationPopupBackground2}</span>
          {informationPopupBackground3}
        </div>
        <br></br>&nbsp;<br></br>
        <div>
          {informationPopupTechnical}
        </div>
        <br></br>&nbsp;<br></br>&nbsp;
        <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
          {informationPopupDeveloper}
        </div>
        <br></br>&nbsp;<br></br>&nbsp;
        <div style={{fontSize: "1.4dvh", textAlign: "center"}}>
          {informationPopupCredits1}
          <br></br>&nbsp;<br></br>
          <div>
            {informationPopupCredits2}
            <a href="https://division-teacher.computatrum.ch/" target="_blank" rel="noopener noreferrer">{informationPopupCredits3}</a>
            {informationPopupCredits4}
          </div>
          <div>
            {informationPopupCredits5}
            <a href="https://www.freepik.com/" title="Freepik" target="_blank" rel="noopener noreferrer">{informationPopupCredits6}</a>
            {informationPopupCredits7}
            <a href="https://www.flaticon.com/free-icons/info" title="Flaticon" target="_blank" rel="noopener noreferrer">{informationPopupCredits8}</a>
            {informationPopupCredits9}
          </div>
        </div>
      </div>
      <button
        onClick={handleClose}
        className="information-close-button"
      >
        {tutorialButtonPreviousPage}
      </button>
    </div>
  );
}

export default InformationPopup;
